// BB FILE: BB custom script: search synonyms (Shopify admin › Content › Metaobjects › Search synonym), keyword suggestions and voice search for the search popup and the search page; any error searches exactly what was typed (user, 2026-10-23)
(function () {
  'use strict';

  /** @type {{tokens: string[], to: string}[] | null} */
  let rules = null;

  /**
   * Lower-cases and folds a query so spellings compare alike: no accents or apostrophes, no Arabic vowel marks,
   * Arabic yeh/kaf as their Persian forms, punctuation and hyphens as spaces.
   * @param {string} text
   * @returns {string}
   */
  function fold(text) {
    return String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u064B-\u065F\u0670\u0640]/g, '')
      .replace(/\u064A/g, '\u06CC')
      .replace(/\u0643/g, '\u06A9')
      .replace(/[\u200C\u200D]/g, '')
      .replace(/[\u2018\u2019\u02BB\u02BC'`\u00B4]/g, '')
      .toLowerCase()
      .replace(/[-_.,;:!?()"“”«»]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function loadRules() {
    if (rules) return rules;
    rules = [];
    try {
      const data = document.getElementById('bb-search-synonyms');
      const list = data ? JSON.parse(data.textContent || '[]') : [];
      for (const entry of list) {
        const to = String((entry && entry.to) || '').trim();
        if (!to || !Array.isArray(entry.from)) continue;
        for (const term of entry.from) {
          const tokens = fold(term).split(' ').filter(Boolean);
          if (tokens.length) rules.push({ tokens, to });
        }
      }
      rules.sort((a, b) => b.tokens.length - a.tokens.length);
    } catch (error) {
      rules = [];
    }
    return rules;
  }

  /**
   * Replaces any word or phrase on the synonym list with its "Search for" text.
   * @param {string} query - What the customer typed
   * @returns {{query: string, from: string | null}} - What to search for, and what was typed if it changed
   */
  function rewrite(query) {
    try {
      const list = loadRules();
      const tokens = fold(query).split(' ').filter(Boolean);
      if (!list.length || !tokens.length) return { query, from: null };
      const out = [];
      let changed = false;
      let i = 0;
      while (i < tokens.length) {
        const hit = list.find(
          (rule) => rule.tokens.length <= tokens.length - i && rule.tokens.every((token, k) => tokens[i + k] === token)
        );
        if (hit) {
          out.push(hit.to);
          i += hit.tokens.length;
          changed = true;
        } else {
          out.push(tokens[i]);
          i += 1;
        }
      }
      return changed ? { query: out.join(' '), from: query } : { query, from: null };
    } catch (error) {
      return { query, from: null };
    }
  }

  /**
   * The "Showing results for … · search instead for …" line.
   * @param {string} query
   * @param {string} from
   * @returns {DocumentFragment}
   */
  function noteContent(query, from) {
    const fragment = document.createDocumentFragment();
    fragment.append('Showing results for ');
    const strong = document.createElement('strong');
    strong.textContent = query;
    fragment.append(strong, ' · ');
    const link = document.createElement('a');
    const url = new URL(searchPath(), location.origin);
    url.searchParams.set('q', from);
    url.searchParams.set('type', 'product');
    url.searchParams.set('bb_raw', '1');
    link.href = url.pathname + url.search;
    link.textContent = `search instead for “${from}”`;
    fragment.append(link);
    return fragment;
  }

  function searchPath() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
  }

  /** @param {string} action */
  function isSearchAction(action) {
    try {
      return new URL(action || '', location.origin).pathname.replace(/\/$/, '') === searchPath().replace(/\/$/, '');
    } catch (error) {
      return false;
    }
  }

  // Forms that go to the search page (the popup's "View all", the search page's own box) search the synonym
  document.addEventListener(
    'submit',
    (event) => {
      try {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !isSearchAction(form.getAttribute('action'))) return;
        const input = form.querySelector('input[name="q"]');
        if (!(input instanceof HTMLInputElement)) return;
        const result = rewrite(input.value);
        form.querySelectorAll('input[name="bb_from"]').forEach((element) => element.remove());
        if (!result.from) return;
        input.value = result.query;
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'bb_from';
        hidden.value = result.from;
        form.append(hidden);
      } catch (error) {
        /* search what was typed */
      }
    },
    true
  );

  // The search page says what it searched for when a synonym was used
  function showPageNote() {
    try {
      const params = new URLSearchParams(location.search);
      const from = params.get('bb_from');
      const query = params.get('q');
      if (!from || !query || !isSearchAction(location.pathname)) return;
      const header = document.querySelector('.search-page__header');
      if (!header) return;
      // A row that follows the header's alignment setting, so the note sits under the search box, not across the page
      const row = document.createElement('div');
      row.className = 'bb-search-note-row';
      const note = document.createElement('p');
      note.className = 'bb-search-note';
      note.append(noteContent(query, from));
      row.append(note);
      header.append(row);
    } catch (error) {
      /* no note */
    }
  }

  /** @type {{text: string, folded: string}[] | null} */
  let suggestionList = null;

  /**
   * Up to five of the store's most searched terms (snippets/bb-search-synonyms.liquid) that contain what was
   * searched for, most searched first.
   * @param {string} query
   * @returns {string[]}
   */
  function suggestions(query) {
    try {
      if (!suggestionList) {
        const data = document.getElementById('bb-search-suggestions');
        const list = data ? JSON.parse(data.textContent || '[]') : [];
        suggestionList = list.map((text) => ({ text: String(text), folded: fold(text) }));
      }
      const folded = fold(query);
      if (folded.length < 2) return [];
      return suggestionList
        .filter((entry) => entry.folded !== folded && entry.folded.includes(folded))
        .slice(0, 5)
        .map((entry) => entry.text);
    } catch (error) {
      return [];
    }
  }

  /**
   * Puts a "Suggestions" list at the top of the popup's left column, making the column if there is none.
   * @param {Document} doc - The parsed popup markup
   * @param {{query: string}} rewrite - What was searched for
   */
  function addSuggestions(doc, rewrite) {
    try {
      const terms = suggestions(rewrite.query);
      const layout = doc.querySelector('.bb-ps__layout');
      if (!terms.length || !layout) return;
      let side = layout.querySelector('.bb-ps__side');
      if (!side) {
        side = doc.createElement('div');
        side.className = 'bb-ps__side';
        layout.prepend(side);
        layout.classList.remove('bb-ps__layout--single');
      }
      const heading = doc.createElement('h4');
      heading.className = 'predictive-search-results__title bb-ps__heading';
      heading.textContent = 'Suggestions';
      const list = doc.createElement('ul');
      list.className = 'predictive-search-results__list bb-ps__links bb-ps__suggestions list-unstyled';
      for (const term of terms) {
        const url = new URL(searchPath(), location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('type', 'product');
        const item = doc.createElement('li');
        item.className = 'bb-ps__link-item';
        item.setAttribute('ref', 'resultsItems[]');
        const link = doc.createElement('a');
        link.className = 'bb-ps__link';
        link.href = url.pathname + url.search;
        link.textContent = term;
        item.append(link);
        list.append(item);
      }
      side.prepend(heading, list);
    } catch (error) {
      /* no suggestions */
    }
  }

  // Voice search: the microphone in the search box (snippets/search-modal.liquid), where the browser can listen
  function setupVoice() {
    try {
      const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!Recognition) return;
      document.querySelectorAll('[data-bb-voice]').forEach((button) => {
        const form = button.closest('form');
        const input = form ? form.querySelector('input[name="q"]') : null;
        if (!(button instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) return;
        button.hidden = false;
        /** @type {any} */
        let listening = null;
        const stopped = () => {
          listening = null;
          button.classList.remove('is-listening');
          button.setAttribute('aria-pressed', 'false');
        };
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (listening) {
            listening.stop();
            return;
          }
          const recognition = new Recognition();
          const pageLanguage = document.documentElement.lang || 'en';
          recognition.lang = pageLanguage.startsWith('en') ? 'en-AU' : pageLanguage;
          recognition.interimResults = false;
          recognition.maxAlternatives = 1;
          recognition.addEventListener('result', (/** @type {any} */ result) => {
            const text = result.results && result.results[0] && result.results[0][0] ? result.results[0][0].transcript : '';
            if (!text) return;
            input.value = text.trim();
            input.focus();
            input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }));
          });
          recognition.addEventListener('end', stopped);
          recognition.addEventListener('error', stopped);
          listening = recognition;
          button.classList.add('is-listening');
          button.setAttribute('aria-pressed', 'true');
          recognition.start();
        });
      });
    } catch (error) {
      /* no voice search */
    }
  }

  function onReady() {
    showPageNote();
    setupVoice();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  window.BBSearch = { rewrite, noteContent, fold, suggestions, addSuggestions };
})();
